import type { TOC } from '@ember/component/template-only'
import type RexDashboardStudentComprehensionLessonProgressIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/comprehension-lesson-progress/index/route'
import RouteTemplate from 'ember-route-template'
import { DashboardStudentComprehensionProgressPage } from 'teacher-ui-client/components/page/reporting/reading-eggspress/dashboard/student/comprehension-progress'

interface Signature {
  Args: { model: ModelFor<RexDashboardStudentComprehensionLessonProgressIndexRoute> }
}

export const DashboardStudentComprehensionLessonProgressIndexPage: TOC<Signature> = <template>
  <DashboardStudentComprehensionProgressPage
    @fetchComprehensionProgressOverviewReportTask={{@model.fetchComprehensionProgressOverviewReportTask}}
    @fetchComprehensionProgressEventsReportTask={{@model.fetchComprehensionProgressEventsReportTask}}
    @fetchComprehensionProgressPlacementEventsReportTask={{@model.fetchComprehensionProgressPlacementEventsReportTask}}
  />
</template>

export default RouteTemplate(DashboardStudentComprehensionLessonProgressIndexPage)
